module.exports = __webpack_public_path__ + "media/images/icons/loading-62df328eca348b95d447f372a44ad265.svg";